// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import Cookies from 'vue-cookies'
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd'
import 'vuejs-clipper/dist/vuejs-clipper.css'
import VueRx from 'vue-rx'
import VueTheMask from 'vue-the-mask'
import VueScrollLoader from 'vue-scroll-loader'
import 'v-mask'
import '@/assets/index.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'quill-mention/dist/quill.mention.min.css'
import './permission'
import './filter/filter.js'
Vue.use(Vuetify, Cookies, {})
Vue.use(VuejsClipper)
Vue.use(VueRx)
Vue.use(VueTheMask)
Vue.use(VueScrollLoader)
const opts = {}

export default
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify: new Vuetify(opts),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js